// DO NOT EXPORT THIS FILE
// use getConfig instead

export default {
  // place config override for dev env here
  isCognitoEnabled: true,
};
